// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3X2c6","col":"styles_col__25s7Q","actions":"styles_actions__1g1hC","conflict":"styles_conflict__1GAKA"};